import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Code2, Server, ArrowRight } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
export function Services() {
  const services = [{
    icon: Zap,
    problem: 'Your team is drowning in repetitive work.',
    title: 'Automation & Custom Workflows',
    description: 'We connect the tools you already use and automate the steps eating your week — quoting, invoicing, handoffs, reporting. The hours come back to your team.',
    link: '/services#automation'
  }, {
    icon: Code2,
    problem: "Off-the-shelf software doesn't fit your business.",
    title: 'Custom Software Development',
    description: 'We build the system your business actually needs — designed around how you work, owned by you, and made to last past the project.',
    link: '/services#software'
  }, {
    icon: Server,
    problem: 'Your cloud bill is unpredictable and no one picks up.',
    title: 'Local Hosting Solutions',
    description: 'Boston-based hosting with flat pricing, real human support, and no lock-in. An alternative when AWS feels like a black box.',
    link: '/services#hosting'
  }];
  return <section className="py-16" data-id="element-148">
      <SectionLabel number="02" label="Where we come in" data-id="element-149" />
      <h2 className="font-display text-4xl md:text-5xl text-ink mb-3 max-w-2xl leading-[1.05]" data-id="element-150">
        Three problems we solve,{' '}
        <span className="italic text-brand-teal" data-id="element-151">all in-house.</span>
      </h2>
      <p className="text-lg text-ink-muted mb-10 max-w-2xl" data-id="element-152">
        No subcontractors. No handoffs. The people you talk to are the people
        writing the code.
      </p>
      <div className="grid md:grid-cols-3 gap-6" data-id="element-153">
        {services.map((service, index) => <motion.article key={service.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-surface-paper rounded-2xl p-6 border border-ink/10 hover:border-brand-teal/40 hover:shadow-card transition-all flex flex-col group" data-id="element-154">
            <div className="flex items-center justify-between mb-6" data-id="element-155">
              <service.icon className="w-10 h-10 text-brand-teal" strokeWidth={1.5} data-id="element-156" />
              <span className="font-display italic text-3xl text-ink/15" data-id="element-157">
                0{index + 1}
              </span>
            </div>
            <p className="font-display italic text-xl text-brand-deep mb-3 leading-snug" data-id="element-158">
              {service.problem}
            </p>
            <h3 className="text-lg font-bold text-ink mb-3" data-id="element-159">{service.title}</h3>
            <p className="text-ink-muted mb-4 leading-relaxed flex-1" data-id="element-160">
              {service.description}
            </p>
            <a href={service.link} className="inline-flex items-center gap-2 text-brand-teal font-semibold group-hover:gap-3 transition-all" data-id="element-161">
              Learn more
              <ArrowRight className="w-4 h-4" data-id="element-162" />
            </a>
          </motion.article>)}
      </div>
    </section>;
}